import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

//ORDER ACCURACY

const VideoUpload = lazy(() => import('src/pages/members/video/VideoUpload'))
const DisputableOrders = lazy(() => import('src/pages/members/video/DisputableOrders'))
const WaitingPage = lazy(() => import('src/pages/public/waiting/WaitingPage'))

// Using GPT
const SearchDatabase = lazy(() => import('src/components/ChatGPTComponents/SearchDatabase'))
// Using GPT
const AskQuestion = lazy(() => import('src/pages/members/Ask/AskQuestion'))

const Redirect = lazy(() => import('src/pages/members/Redirect/Redirect'))

// Test Chat Page for Conversational Layer Agent
const TestChatPage = lazy(() => import('src/pages/members/TestChatPage'))

export const coreRoutes: RouteObject[] = [
  { path: 'create-account/wait', element: <WaitingPage /> },
  { path: 'ask', element: <AskQuestion /> },
  { path: 'search', element: <SearchDatabase /> },
  { path: 'redirect', element: <Redirect /> },
  { path: 'video', element: <VideoUpload /> },
  { path: 'video/:order', element: <DisputableOrders /> },
  { path: 'test-chat', element: <TestChatPage /> }
]
